import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { BusyIndicatorMessageManager } from 'src/app/Busy-Indicator';
import { IWeissmanModalComponent } from 'src/app/Compliance/WeissmanModalService';

@Component({
    selector: 'check-import-modal',
    template: `
        @if (busyIndicatorMessageManager.count() > 0) {
          <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
        }

        <ws-modal-wrapper headerLabel="Import Checks"
          (save)="returnFile()"
          (cancel)="cancel()"
          acceptLabel="Import"
          [disableSave]="!file">
          <div class="ws-flex-container-vertical ws-stretch">
            <p>
                Upload the check register/import file returned by your bank or lockbox provider.
                This should be the actual production file you received &mdash; not a file you create
                or fill out manually.
            </p>
            <ws-file-picker acceptTypes=".csv,.xls,.xlsx" (picked)="filesPicked($event)"></ws-file-picker>
            <p>
                Need an example of the expected format?
                <a href="assets/sample-check-import.xlsx" download>Download reference sample</a>
                &mdash; for reference/QA purposes only; do not upload this file.
            </p>
          </div>
        </ws-modal-wrapper>
        `,
    standalone: false
})


export class CheckImportModalComponent implements IWeissmanModalComponent<number, File> {
    constructor(
        private readonly _bsModalRef: BsModalRef,
        private readonly _toastr: ToastrService
    ) {
    }

    params: number;
    result: File;

    busyIndicatorMessageManager = new BusyIndicatorMessageManager<string>();

    file: File;

    filesPicked(files: File[]) {
        if (files.length) {
            this.file = files[0];
        }

        const { name } = files[0];
        const index = name.lastIndexOf('.');
        if (index !== 0) {
            const fileExtension = name.substr(index + 1).toLowerCase();
            if (fileExtension === 'csv' || fileExtension === 'xls' || fileExtension === 'xlsx') {
                this.file = files[0];
            } else {
                this._toastr.error('Only .csv, .xls, or .xlsx file formats are allowed.');
                this.file = undefined;
            }
        }
    }

    async returnFile() {
        this.result = this.file;
        this._bsModalRef.hide();
    }

    cancel() {
        this._bsModalRef.hide();
    }

}
